import React, { useEffect, useState } from "react";
import { styled, useTheme, alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Logo from "../images/logo.png";
import { useMediaQuery, Badge, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";
import Notificationss from "../../Components/Notifications/Notifications";
import CandidateNotification from "../../Components/Notifications/Candidatenotifications";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";
import PersonRemoveOutlinedIcon from "@mui/icons-material/PersonRemoveOutlined";
import PermContactCalendarOutlinedIcon from "@mui/icons-material/PermContactCalendarOutlined";
import SourceOutlinedIcon from "@mui/icons-material/SourceOutlined";
import { useNavigate } from "react-router-dom";
import {
  BusinessCenterOutlined,
  CalendarMonth,
  DashboardCustomizeOutlined,
  GroupsOutlined,
  LocationCityOutlined,
  PersonOutlineOutlined,
  WorkOutlineOutlined,
  AssignmentIndOutlined,
  AdminPanelSettingsOutlined,
  PeopleAltOutlined,
  PersonOffOutlined,
  DescriptionOutlined,
  TaskAltOutlined,
  ContactPageOutlined,
  SourceOutlined,
  EventNoteOutlined,
  FolderOpenOutlined,
} from "@mui/icons-material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import EmailIcon from "@mui/icons-material/Email";
import LogoutIcon from "@mui/icons-material/Logout";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import { InputBase, Paper, Slide, Switch } from "@mui/material";
import { useLocation, Link } from "react-router-dom";
import { Link as MuiLink } from "@mui/material";
import { Avatar, Menu, MenuItem, Modal, Stack, Tooltip } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Key from "../../clientVariables.json";
import moment from "moment";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import "./styles.css";
import { userSelector } from "../user-redux/selector";
import { userLogout } from "../user-redux/action";
import Mailer from "../candidatesPage/Mailer";
import { appSelector } from "../redux/selector";
import UserAvatar from "./UserAvatar";
import { getActiveCandidatesAction, updatePackageAlertLogAction } from "../redux/action";
import { clearSubmissionViewStateAction } from "../MyCandidates/redux/action";
import NotificationsIcon from "@mui/icons-material/Notifications";

const drawerWidth = 260;
const modalStyles = {
  width: "90%",
  maxWidth: "1200px",
  bgcolor: "background.paper",
  boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)",
  p: 0,
  borderRadius: "12px",
  maxHeight: "85vh",
  outline: "none",
};

// Professional Search Component
const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: "12px",
  backgroundColor: "rgba(255, 255, 255, 0.95)",
  backdropFilter: "blur(10px)",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 1)",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
  },
  "&:focus-within": {
    boxShadow: "0 0 0 2px rgba(33, 150, 243, 0.2)",
  },
  color: "#1a1a1a",
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  maxWidth: "400px",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto",
  },
  transition: "all 0.3s ease-in-out",
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#666",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "#1a1a1a",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1.25, 1, 1.25, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    fontSize: "14px",
    fontWeight: 500,
    [theme.breakpoints.up("md")]: {
      width: "40ch",
    },
  },
  input: {
    "&::placeholder": {
      textOverflow: "ellipsis !important",
      color: "rgba(0,0,0,0.6)",
      fontWeight: 400,
    },
  },
}));

// Enhanced Drawer Styles
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
  background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
  borderRight: "1px solid rgba(0, 0, 0, 0.08)",
  boxShadow: "4px 0 20px rgba(0, 0, 0, 0.08)",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(9)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(9)} + 1px)`,
  },
  background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
  borderRight: "1px solid rgba(0, 0, 0, 0.08)",
  boxShadow: "4px 0 20px rgba(0, 0, 0, 0.08)",
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(2, 1),
  ...theme.mixins.toolbar,
  background: "#ffffff",
  borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
}));

// Professional AppBar
const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  background: "#ffffff",
  backdropFilter: "blur(20px)",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
  border: "1px solid rgba(0, 0, 0, 0.08)",
  borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
  ...(open && {
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

// Enhanced Drawer
const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

// Professional Nav Item Button
const NavItemButton = styled(ListItemButton)(({ theme, selected }) => ({
  margin: "4px 8px",
  borderRadius: "12px",
  minHeight: "56px",
  backgroundColor: selected ? "rgba(33, 150, 243, 0.08)" : "transparent",
  border: selected ? "1px solid rgba(33, 150, 243, 0.2)" : "1px solid transparent",
  boxShadow: selected ? "0 2px 8px rgba(33, 150, 243, 0.15)" : "none",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  "&:hover": {
    backgroundColor: selected ? "rgba(33, 150, 243, 0.12)" : "rgba(0, 0, 0, 0.04)",
    transform: "translateY(-1px)",
    boxShadow: selected
      ? "0 4px 12px rgba(33, 150, 243, 0.2)"
      : "0 2px 8px rgba(0, 0, 0, 0.1)",
  },
  "&:before": {
    content: '""',
    position: "absolute",
    left: 0,
    top: "50%",
    transform: "translateY(-50%)",
    width: selected ? "4px" : "0px",
    height: "60%",
    backgroundColor: "#2196f3",
    borderRadius: "0 4px 4px 0",
    transition: "width 0.3s ease",
  },
}));

const ITEM_HEIGHT = 48;

const NavBar = ({ children }) => {
  const theme = useTheme();
  const isMobileSmall = useMediaQuery(theme.breakpoints.down("xs"));
  const isMobile = useMediaQuery(theme.breakpoints.between("xs", "sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const isDesktopSmall = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const isDesktopLarge = useMediaQuery(theme.breakpoints.up("lg"));

  const { user } = useSelector(userSelector);
  const [open, setOpen] = useState(false);
  const { loginCandidate, activeCandidates } = useSelector(appSelector);
  const [openMobile, setOpenMobile] = useState(false);
  const [sideNavItemIndex, setSideNavItemIndex] = useState(0);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const location = useLocation();
  const dispatch = useDispatch();
  const [mailOpen, setMailopen] = useState(false);
  const navigate = useNavigate();
  const [isToggleOn, setIsToggleOn] = useState(false);

  const { packageAlertData } = useSelector(appSelector);
  const [showPackageAlert, setShowPackageAlert] = useState(false);

  useEffect(() => {
    if (packageAlertData?.showAlert) {
      setShowPackageAlert(true);
    }
  }, [packageAlertData]);

  const handlePackageAlertClose = () => {
    setShowPackageAlert(false);
    if (packageAlertData && user) {
      dispatch(
        updatePackageAlertLogAction({
          company_id: user.companyid,
          user_id: user.id,
          package_id: packageAlertData?.data?.id,
        })
      );
    }
  };

  const handleToggle = () => {
    setIsToggleOn(!isToggleOn);
  };

  const handleDrawerToggle = () => {
    if (isDesktop) {
      setOpen((prevState) => !prevState);
    } else {
      setOpenMobile((prevState) => !prevState);
    }
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleProfileClick = () => {
    navigate("/profile-view");
    handleCloseUserMenu();
  };

  const navItemOnClickHandler = (title, index) => {
    setSideNavItemIndex(index);
    // Clear sticky Submissions selection/tab when using left navbar
    dispatch(clearSubmissionViewStateAction());
  };

  useEffect(() => {
    const currentPath = location.pathname;
    const selectedIndex = navItems.findIndex((item) => item.to === currentPath);
    setSideNavItemIndex(selectedIndex !== -1 ? selectedIndex : 0);
  }, [location.pathname]);

  const navItemsConfig = {
    3: [
      {
        title: "Dashboard",
        to: "/",
        icon: <DashboardCustomizeOutlined sx={{ fontSize: "22px" }} />,
      },
      {
        title: "My Candidates",
        to: "/my-candidates",
        icon: <PeopleAltOutlined sx={{ fontSize: "22px" }} />,
      },
      {
        title: "Companies",
        to: "/companies",
        icon: <LocationCityOutlined sx={{ fontSize: "22px" }} />,
      },
      {
        title: "Sources",
        to: "/sources",
        icon: <SourceOutlined sx={{ fontSize: "22px" }} />,
      },
      {
        title: "Contacts",
        to: "/contacts",
        icon: <ContactPageOutlined sx={{ fontSize: "22px" }} />,
      },
      {
        title: "Inactive",
        to: "/inactive-candidates",
        icon: <PersonOffOutlined sx={{ fontSize: "22px" }} />,
      },
      {
        title: "JobFair Candidates",
        to: "/job-fair-candidates",
        icon: <EventNoteOutlined sx={{ fontSize: "22px" }} />,
      },
    ],
    6: [
      {
        title: "Dashboard",
        to: "/candidate-dashboard",
        icon: <DashboardCustomizeOutlined sx={{ fontSize: "22px" }} />,
      },
      {
        title: "Profiles",
        to: "/profiles",
        icon: <AssignmentIndOutlined sx={{ fontSize: "22px" }} />,
      },
      {
        title: "Jobs",
        to: "/candidates-list",
        icon: <WorkOutlineOutlined sx={{ fontSize: "22px" }} />,
      },
      {
        title: "Calendar",
        to: "/calendar",
        icon: <EventNoteOutlined sx={{ fontSize: "22px" }} />,
      },
      {
        title: "Todo",
        to: "/todo-list",
        icon: <TaskAltOutlined sx={{ fontSize: "22px" }} />,
      },
      {
        title: "Documents",
        to: "/documents",
        icon: <FolderOpenOutlined sx={{ fontSize: "22px" }} />,
      },
    ],
    7: [
      {
        title: "Dashboard",
        to: "/admin-dashboard",
        icon: <AdminPanelSettingsOutlined sx={{ fontSize: "22px" }} />,
      },
      {
        title: "Recruiters",
        to: "/admin-allocation",
        icon: <GroupsOutlined sx={{ fontSize: "22px" }} />,
      },
      {
        title: "Candidates",
        to: "/admin-candidates",
        icon: <PeopleAltOutlined sx={{ fontSize: "22px" }} />,
      },
      {
        title: "Inactive Recruiters",
        to: "/adminin-active-recruiters",
        icon: <PersonOffOutlined sx={{ fontSize: "22px" }} />,
      },
      {
        title: "My Candidates",
        to: "/my-candidates",
        icon: <PeopleAltOutlined sx={{ fontSize: "22px" }} />,
      },
      {
        title: "Companies",
        to: "/companies",
        icon: <LocationCityOutlined sx={{ fontSize: "22px" }} />,
      },
      {
        title: "Sources",
        to: "/sources",
        icon: <SourceOutlined sx={{ fontSize: "22px" }} />,
      },
      {
        title: "Contacts",
        to: "/contacts",
        icon: <ContactPageOutlined sx={{ fontSize: "22px" }} />,
      },
      {
        title: "Inactive Candidates",
        to: "/inactive-candidates",
        icon: <PersonOffOutlined sx={{ fontSize: "22px" }} />,
      },
    ],
    13: [
      {
        title: "Dashboard",
        to: "/admin-dashboard",
        icon: <AdminPanelSettingsOutlined sx={{ fontSize: "22px" }} />,
      },
      {
        title: "Recruiters",
        to: "/admin-allocation",
        icon: <GroupsOutlined sx={{ fontSize: "22px" }} />,
      },
      {
        title: "Candidates",
        to: "/admin-candidates",
        icon: <PeopleAltOutlined sx={{ fontSize: "22px" }} />,
      },
      {
        title: "Inactive Recruiters",
        to: "/adminin-active-recruiters",
        icon: <PersonOffOutlined sx={{ fontSize: "22px" }} />,
      },
      {
        title: "My Candidates",
        to: "/my-candidates",
        icon: <PeopleAltOutlined sx={{ fontSize: "22px" }} />,
      },
      {
        title: "Companies",
        to: "/companies",
        icon: <LocationCityOutlined sx={{ fontSize: "22px" }} />,
      },
      {
        title: "Sources",
        to: "/sources",
        icon: <SourceOutlined sx={{ fontSize: "22px" }} />,
      },
      {
        title: "Contacts",
        to: "/contacts",
        icon: <ContactPageOutlined sx={{ fontSize: "22px" }} />,
      },
      {
        title: "Inactive Candidates",
        to: "/inactive-candidates",
        icon: <PersonOffOutlined sx={{ fontSize: "22px" }} />,
      },
      {
        title: "JobFair Candidates",
        to: "/job-fair-candidates",
        icon: <EventNoteOutlined sx={{ fontSize: "22px" }} />,
      },
    ],
  };

  const navItems =
    user?.usertype == 13 && isToggleOn
      ? navItemsConfig[3]
      : navItemsConfig[user?.usertype] || [];
  const filteredNavItems =
    user?.usertype == 7 && isToggleOn ? navItems.slice(0, 5) : navItems;

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <DrawerHeader>
        <Link to="/" style={{ textDecoration: "none" }}>
          <img
            src="https://jobsnprofiles.com/static/media/jobsnProfiles.54d22dc53e022b59b8b7.png"
            width={140}
          />
        </Link>
      </DrawerHeader>
      <Divider sx={{ backgroundColor: "rgba(0, 0, 0, 0.08)" }} />
      <List sx={{ padding: "16px 0" }}>
        {navItems.map((item, index) => (
          <ListItem key={index} disablePadding>
            <Link
              to={item.to}
              style={{ textDecoration: "none", width: "100%" }}
              onClick={() => navItemOnClickHandler(item?.title, index)}
            >
              <NavItemButton selected={sideNavItemIndex === index}>
                <ListItemIcon
                  sx={{
                    minWidth: "40px",
                    color: sideNavItemIndex === index ? "#0052CC" : "#5C6BC0",
                    transition: "all 0.3s ease",
                    transform: sideNavItemIndex === index ? "scale(1.05)" : "scale(1)",
                    filter: sideNavItemIndex === index ? "drop-shadow(0 2px 4px rgba(0, 82, 204, 0.25))" : "none",
                    opacity: sideNavItemIndex === index ? 1 : 0.75,
                    "&:hover": {
                      color: sideNavItemIndex === index ? "#0052CC" : "#3949AB",
                      opacity: 1,
                      transform: "scale(1.05)"
                    }
                  }}>
                  {item.icon}
                </ListItemIcon>
                <ListItemText
                  primary={item.title}
                  sx={{
                    color: "rgba(0, 0, 0, 0.87)",
                    "& .MuiListItemText-primary": {
                      fontSize: "14px",
                      fontWeight: sideNavItemIndex === index ? 600 : 500,
                    }
                  }}
                />
              </NavItemButton>
            </Link>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar position="fixed" open={open}>
        <Toolbar sx={{ minHeight: "64px !important", padding: "0 16px" }}>
          <IconButton
            color="inherit"
            aria-label="toggle drawer"
            onClick={handleDrawerToggle}
            edge="start"
            sx={{
              mr: 2,
              color: "#333",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.04)",
              }
            }}
          >
            <MenuIcon />
          </IconButton>


          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            <img
              src={Logo}
              alt="logo"
              style={{
                cursor: "pointer",
                width: "160px"
              }}
            />
          </Box>


          <Box sx={{ flexGrow: 1 }} />

          {/* Search Bar */}
          {/* <Search>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="Search anything..."
              inputProps={{ "aria-label": "search" }}
            />
          </Search> */}

          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {/* Notifications */}
            {/* {!isMobile && !isTablet && (
              <IconButton
                size="medium"
                aria-label="notifications"
                sx={{
                  color: "#666",
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.04)",
                  }
                }}
              >
                <Badge badgeContent={4} color="error">
                  <NotificationsIcon />
                </Badge>
              </IconButton>
            )} */}

            {/* User Avatar */}
            <UserAvatar
              user={user}
              handleOpenUserMenu={handleOpenUserMenu}
              sx={{
                border: "2px solid #2196f3", // Add border color
                borderRadius: "50%", // Ensure circular border
              }}
            />

            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
              PaperProps={{
                elevation: 8,
                sx: {
                  borderRadius: "12px",
                  border: "1px solid rgba(0, 0, 0, 0.08)",
                  minWidth: 200,
                  "& .MuiMenuItem-root": {
                    padding: "12px 16px",
                    fontSize: "14px",
                    "&:hover": {
                      backgroundColor: "rgba(33, 150, 243, 0.08)",
                    }
                  }
                }
              }}
            >
              <MenuItem onClick={handleProfileClick}>
                <ListItemIcon>
                  <AccountCircleIcon fontSize="small" sx={{ color: "#666" }} />
                </ListItemIcon>
                <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                  Profile
                </Typography>
              </MenuItem>
              {user.usertype != 6 && <MenuItem onClick={() => {
                if (!activeCandidates || activeCandidates.length === 0) {
                  dispatch(getActiveCandidatesAction(user?.id, 1, 25));
                }
                setMailopen(true);
              }}>
                <ListItemIcon>
                  <EmailIcon fontSize="small" sx={{ color: "#666" }} />
                </ListItemIcon>
                <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                  Email Campaign
                </Typography>
              </MenuItem>}
              <Divider />
              <MenuItem onClick={() =>
                dispatch(
                  userLogout({
                    userid: user.id,
                  })
                )
              }>
                <ListItemIcon>
                  <LogoutIcon fontSize="small" sx={{ color: "#f44336" }} />
                </ListItemIcon>
                <Typography sx={{ fontSize: "14px", fontWeight: 500, color: "#f44336" }}>
                  Logout
                </Typography>
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Desktop Drawer */}
      <Drawer
        variant="permanent"
        open={open}
        sx={{ display: { xs: "none", md: "block" } }}
      >
        {open && (
          <DrawerHeader>
            <Link to="/" style={{ textDecoration: "none" }}>
              <img
                src="https://jobsnprofiles.com/static/media/jobsnProfiles.54d22dc53e022b59b8b7.png"
                width={160}
              />
            </Link>
          </DrawerHeader>
        )}

        <List sx={{ pt: open ? "16px" : "80px", px: 1 }}>
          {navItems?.map((item, index) => (
            <ListItem key={index} disablePadding sx={{ display: "block", mb: 0.5 }}>
              <Tooltip
                title={!open ? item?.title : ""}
                placement="right"
                arrow
              >
                <Link to={item?.to} style={{ textDecoration: "none" }}>
                  <NavItemButton
                    onClick={() => navItemOnClickHandler(item?.title, index)}
                    selected={sideNavItemIndex === index}
                    sx={{
                      justifyContent: open ? "initial" : "center",
                      px: open ? 2 : 1.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 2 : "auto",
                        justifyContent: "center",
                        color: sideNavItemIndex === index ? "#0052CC" : "rgb(0, 82, 204)",
                        transition: "all 0.3s ease",
                        transform: sideNavItemIndex === index ? "scale(1.05)" : "scale(1)",
                        filter: sideNavItemIndex === index ? "drop-shadow(0 2px 4px rgba(0, 82, 204, 0.25))" : "none",
                        opacity: sideNavItemIndex === index ? 1 : 0.75,
                        "&:hover": {
                          color: sideNavItemIndex === index ? "#0052CC" : "rgb(0, 82, 204)",
                          opacity: 1,
                          transform: "scale(1.05)"
                        }
                      }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    {open && (
                      <ListItemText
                        primary={item.title}
                        sx={{
                          "& .MuiListItemText-primary": {
                            fontSize: "14px",
                            fontWeight: sideNavItemIndex === index ? 600 : 500,
                            color: sideNavItemIndex === index ? "#2196f3" : "#333",
                          }
                        }}
                      />
                    )}
                  </NavItemButton>
                </Link>
              </Tooltip>
            </ListItem>
          ))}
        </List>
      </Drawer>

      {/* Mobile Drawer */}
      <MuiDrawer
        open={openMobile}
        onClose={handleDrawerToggle}
        sx={{
          zIndex: 1301,
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
            borderRight: "none",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
          }
        }}
      >
        {drawer}
      </MuiDrawer>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pl: { xs: 1, md: 2 },
          pr: { xs: 1, md: 2 },
          marginTop: "64px",
          backgroundColor: "#f8fafc",
          minHeight: "calc(100vh - 64px)",
        }}
      >
        {children}
      </Box>

      {/* Email Modal */}
      <Modal
        open={mailOpen}
        onClose={() => setMailopen(false)}
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Slide
          direction="left"
          in={mailOpen}
          mountOnEnter
          unmountOnExit
          timeout={{ enter: 1000, exit: 1000 }}
          style={{
            transitionTimingFunction: "cubic-bezier(0.68, -0.55, 0.27, 1.55)",
            width: "90%",
            maxWidth: "1200px",
            outline: "none",
          }}
        >
          <Paper
            elevation={4}
            sx={{
              ...modalStyles,
              width: "100%",
              maxWidth: "1200px",
              transition: "transform 0.5s ease-in-out",
              overflow: "hidden",
              overflowY: "hidden",
              display: "flex",
              flexDirection: "column",
              height: "85vh",
              maxHeight: "85vh",
            }}
          >
            <Mailer setMailopen={setMailopen} />
          </Paper>
        </Slide>
      </Modal>
      <Dialog
        open={showPackageAlert}
        onClose={handlePackageAlertClose}
        PaperProps={{
          sx: { borderRadius: "12px", padding: "8px" }
        }}
      >
        <DialogTitle sx={{ color: "#1976d2", fontWeight: "bold", pb: 1 }}>
          Subscription Ending Soon
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ color: "#333", fontSize: "0.95rem" }}>
            Your subscription will end soon. Please ensure you maintain a
            <strong> sufficient balance</strong> in your account for the automatic deduction.

            <Box sx={{ mt: 3, mb: 3, p: 2, bgcolor: "#f8f9fa", borderRadius: "8px", border: "1px solid #e9ecef" }}>
              <Typography variant="body2" sx={{ mb: 1, color: "#495057" }}>
                <strong>Days Left:</strong> {packageAlertData?.daysLeft}
              </Typography>
              <Typography variant="body2" sx={{ color: "#495057" }}>
                <strong>Renewal Date:</strong> {packageAlertData?.expiryDate ? new Date(packageAlertData.expiryDate).toLocaleDateString() : ""}
              </Typography>
            </Box>

            <Typography variant="body2" sx={{ color: "#6c757d", mt: 2 }}>
              For plan upgrading or to explore more subscription plans, please contact our sales team.
            </Typography>

            <Typography variant="body2" sx={{ color: "#6c757d", mt: 1 }}>
              If you wish to cancel your subscription, please contact our sales team.
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 0 }}>
          <Button
            onClick={handlePackageAlertClose}
            variant="contained"
            sx={{
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: "bold",
              px: 3
            }}
          >
            Okay, I understand
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default NavBar;